import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          if (triggerQuestionSelectMetaList.length === 1) {
            const { categoryName, questionDisplayNumber, selectText } = triggerQuestionSelectMetaList[0]
            return `${categoryName} 의 ${questionDisplayNumber} 번째 문항에서 '${selectText}' 라고 응답한 분에게 묻습니다(필수 응답)`
          }

          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `${categoryName} 의 ${questionDisplayNumber} 번째 문항에서 '${selectText}' `
            }
          )
          return `${messages.join(', 또는')} 라고 응답한 분에게 묻습니다.(필수 응답)`
        }),
    },
    validation: {
      decimal_max_digit: '소수점 아래 {decimalMaxDigit}자리까지 입력해 주세요.',
    },
  }
}
